var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('v-btn',{attrs:{"text":"","small":""}},[_vm._v(_vm._s(_vm.$t('msg.feedback')))]),_c('span',[_vm._v("Smarthome © "+_vm._s(_vm.year))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }